import React, { useState, useEffect, useContext, useRef } from 'react';
import StepWizard from "react-step-wizard";
import { makeStyles, withStyles} from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import {
     createMuiTheme, Toolbar, Typography, CssBaseline,  Button, Divider, TextField, FormControl, Select
    , Tooltip, Backdrop, CircularProgress, Radio, RadioGroup, FormControlLabel, Snackbar, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails
    ,  Grid, AppBar
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveTeamCoachOfflineData } from "../../offline/dataService/teamCoachOfflineData";
import { ThemeProvider } from '@material-ui/styles';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from "../contexts/siteContext";
import { Theme } from '../contexts/themeContext';
import { User } from '../contexts/userContext.js';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import SaveWarningDialog from '../common/saveWarningDialog';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';
import FullScreenDialog from '../common/fullScreenDialog.js';
import StepConnector from '@material-ui/core/StepConnector';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import ContentDialog from '../common/contentDialog.js';
import RandomIcon from '../../images/Shape.png';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '10px 0px',
            width: '100%',
            padding: '10px'
        }
    },
    '.MuiExpansionPanelDetails-root': {
        display: 'inline !important'
    },
    ddl: {
        width: '100%',
        margin: '10px 0px'
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    colorCode: {
        marginRight: '5px', color: 'inherit'
    },
    legend: {
        width: '16px',
        height: '16px',
        display: 'inline-block'
    },
    listIcon: {
        float: 'left',
        marginRight: '5px'
    },
    listIconRight: {
        marginLeft: '25px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    locationInput: {
        '& > .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
            padding: '0px'
        }
    }
}));

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: '#0C76D8',
        },
    },
    completed: {
        '& $line': {
            borderColor: '#0C76D8',
        },
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: '#0C76D8',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#0C76D8',
        zIndex: 1,
        fontSize: 24,
    },
});

function getSteps() {
    return ['Survey Type', 'Supervisor/Employee', 'Location', 'Survey'];
}

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <RadioButtonCheckedIcon className={classes.completed} /> : <RadioButtonUncheckedIcon/>}
        </div>
    );
}

const SupervisorEmployee = props => {
    const { surveyTemplate, supervisors, supervisorId, onSupervisorChange, employees, employeeId, onEmployeeChange, interviewee, onIntervieweeChange, generateFromQueue, Stats } = props;
    
    return (
        <div>
            <Stats step={1} {...props} />
            <h3>Supervisor/Employee</h3>
            <br />
            <Typography variant="subtitle2" gutterBottom>
                Supervisor
                {
                    surveyTemplate.SupervisorMandatory &&
                    <span style={{ color: 'red' }}>*</span>
                }
                {
                    !surveyTemplate.SupervisorMandatory &&
                    <> (optional)</>
                }
            </Typography>
            <FormControl required={surveyTemplate.SupervisorMandatory} variant="outlined" margin="dense" style={{ marginTop: "0px", width: '100%' }}>
                <Select style={{ width: '100%', color: 'inherit' }}
                    native
                    size="small"
                    disabled={generateFromQueue}
                    value={supervisorId}
                    onChange={onSupervisorChange}
                >
                    <option aria-label="None" key="0" value="" />
                    {
                        supervisors.map((option, key) => {
                            return <option key={option.PplPerson} value={option.PplPerson} label={option.Title}>{option.Title}</option>;
                        })
                    }
                </Select>
            </FormControl>
            <br/><br/>
            <Typography variant="subtitle2" gutterBottom>
                Employee
                {
                    surveyTemplate.EmployeeMandatory &&
                    <span style={{ color: 'red' }}>*</span>
                }
                {
                    !surveyTemplate.EmployeeMandatory &&
                    <> (optional)</>
                }
            </Typography>
            <FormControl required={surveyTemplate.EmployeeMandatory} variant="outlined" margin="dense" style={{ marginTop: "0px",width: '100%' }}>
                <Select style={{ width: '100%', color: 'inherit' }}
                    native
                    size="small"
                    value={employeeId}
                    onChange={onEmployeeChange}
                >
                    <option aria-label="None" key="0" value="" />
                    {
                        employees.map((option, key) => {
                            return <option key={option.PplPerson} value={option.PplPerson} label={option.Title}>{option.Title}</option>;
                        })
                    }
                </Select>
            </FormControl>
            <br /><br />
            <Typography variant="subtitle2" gutterBottom>
                Interviewee
                {
                    surveyTemplate.IntervieweeMandatory &&
                    <span style={{ color: 'red' }}>*</span>
                }
                {
                    !surveyTemplate.IntervieweeMandatory &&
                    <> (optional)</>
                }
            </Typography>
            <TextField
                id="Interviewee"
                size="small"
                required={surveyTemplate.IntervieweeMandatory}
                value={interviewee}
                onChange={onIntervieweeChange}
                variant="outlined"
                style={{ width: "100%", clear: "both", marginTop: "10px" }}
            />
            <div className="mt-4 d-flex justify-content-end">
                <Button variant="outlined" size="small" className="mr-3" style={{ color: props.currentTheme.secondary}}
                    onClick={() => { props.handleBack(() => { props.goToStep(props.currentStep - 1) }) }}
                >
                    Back
                </Button>
                <Button size="small" variant="contained" color="primary" style={{ background: props.currentTheme.secondary }} onClick={() => { props.handleNext(() => { props.goToStep(props.currentStep + 1) }) }}>
                    Next
                </Button>
            </div>
        </div>
    );
};

export default function TeamCoachList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const refSections = useRef([]);
    const refQuestions = useRef([]);
    const labelRef = useRef();
    const buttonRef = useRef();
    const { comeFrom, rodTab, getHirnode, goToComeFrom, roundLocationPath } = props;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { userDetail, getCurrentUserDetails } = useContext(User);
    const [coachId, setCoachId] = useState(0);
    const [templateId, setTemplateId] = React.useState(0);
    const [queueCount, setQueueCount] = React.useState(0);
    const [queueList, setQueueList] = React.useState([]);
    const [queueListBase, setQueueListBase] = React.useState([]);
    const [svyGeneratedSurveyId, setSvyGeneratedSurveyId] = useState(0);
    const [generateFromQueue, setGenerateFromQueue] = useState(false);
    const [functionalAreas, setFunctionalAreas] = useState([]);
    const [functionalAreasAll, setFunctionalAreasAll] = useState([]);
    const [functionalArea, setFunctionalArea] = useState([]);
    const [functionalAreaId, setFunctionalAreaId] = useState(0);
    const [functionalAreaName, setFunctionalAreaName] = useState("All");
    const [surveyTypes, setSurveyTypes] = useState([]);
    const [surveyTypesAll, setSurveyTypesAll] = useState([]);
    const [surveyType, setSurveyType] = useState([]);
    const [surveyTypeId, setSurveyTypeId] = useState(0);
    const [surveyTypeName, setSurveyTypeName] = useState("All");
    const [supervisorName, setSupervisorName] = useState("All");
    const [surveyTemplates, setSurveyTemplates] = useState([]);
    const [surveyTemplate, setSurveyTemplate] = useState([]);
    const [surveyTemplateId, setSurveyTemplateId] = useState(0);
    const [templateSections, setTemplateSections] = useState([]);
    const [templateSectionsBase, setTemplateSectionsBase] = useState([]);
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const [generalComments, setGeneralComments] = useState([]);
    const [dateFrom, setDateFrom] = useState(moment().day(0).format('L'));
    const [dateTo, setDateTo] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [inspectionDate, setInspectionDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [supervisors, setSupervisors] = useState([]);
    const [supervisorsAll, setSupervisorsAll] = useState([]);
    const [supervisor, setSupervisor] = useState([]);
    const [supervisorId, setSupervisorId] = useState(0);
    const [employees, setEmployees] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [employeeId, setEmployeeId] = useState(0);
    const [interviewee, setInterviewee] = useState("");
    const [locations, setLocations] = useState([]);
    const [location, setLocation] = useState([]);
    const [locationSearchHistory, setLocationSearchHistory] = useState("");
    const [locationExists, setLocationExists] = useState(false);
    const [employeeDisable, setEmployeeDisable] = useState(true);
    const [locationDisable, setLocationDisable] = useState(true);
    const [templateDisable, setTemplateDisable] = useState(true);
    const [locationIcon, setLocationIcon] = useState("3");
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [queueListOpen, setQueueListOpen] = React.useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [actionMessage, setActionMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loadCount, setLoadCount] = useState(0);
    const [modified, setModified] = useState(false);
    const [saveConfirmOpen, setSaveConfirmOpen] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const updateLoadCount = (add) => {
        if (add)
            setLoadCount(loadCount => (loadCount + 1));
        else
            setLoadCount(loadCount => (loadCount - 1));
    };

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const cancel = () => {
        TransactionTime.cancel();
        if (comeFrom === "RDOAccountVisitation" || comeFrom === "Round")
            goToComeFrom();
        else
            props.history.push('/');
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const saveConfirmClose = () => {
        setSaveConfirmOpen(false);
    };

    const saveData = () => {
        buttonRef.current.click();
    };

    const triggerSave = () => {
        if (modified) {
            setSaveConfirmOpen(true);
        }
        else
            cancel();
    };

    const openQueueList = () => {
        setQueueList(queueListBase);
        setQueueListOpen(true);
    };

    const getShortName = (name) => {
        if (name !== null && name !== undefined && name !== "") {
            if (name.indexOf("\\") === -1)
                return name;
            else
                return ".." + name.substring(name.indexOf("\\"));
        }
    };

    const getFunctionalAreas = () => {
        updateLoadCount(true);
        HttpService.post('/TeamCoach/GetAppFunctionalAreas', {
            PplPersonId: userDetail.PplPerson.toString()
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppFunctionalAreas");
                    result.data = offlineResult.OfflineData.data;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "AppFunctionalAreas");
                    offlineService.addOffline(defaultSite.id, "AppFunctionalAreas", result);
                }
                setFunctionalAreas(result.data);
                var data = result.data.slice();
                data.unshift({ AppFunctionalAreaId: 0, AppFunaTitle: "All" });
                setFunctionalAreasAll(data);
                updateLoadCount(false);

                if (comeFrom === "RDOAccountVisitation" && rodTab === "Tab1") {
                    let item = result.data.find(item => item.AppFunaTitle === "Environmental");
                    if (item) {
                        setFunctionalArea(item);
                        setFunctionalAreaId(item.AppFunctionalAreaId);
                    }
                }
                else {
                    result.data.forEach(item => {
                        if (item.defaultTitle) {
                            setFunctionalArea(item);
                            setFunctionalAreaId(item.AppFunctionalAreaId);
                        }
                    })
                }
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const getSurveyTypes = () => {
        updateLoadCount(true);
        HttpService.post('/TeamCoach/GetAllSurveyTypes', {})
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "SurveyTypes");
                    result.data = offlineResult.OfflineData.data;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "SurveyTypes");
                    offlineService.addOffline(defaultSite.id, "SurveyTypes", result);
                }
                setSurveyTypes(result.data);
                var data = result.data.slice();
                data.unshift({ SvySurveyTypeId: 0, Title: "All" });
                setSurveyTypesAll(data);
                updateLoadCount(false);

                if (comeFrom === "RDOAccountVisitation" && rodTab === "Tab1") {
                    let item = result.data.find(item => item.Title === "Survey");
                    if (item) {
                        setSurveyType(item);
                        setSurveyTypeId(item.SvySurveyTypeId);
                    }
                }
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const getSurveyTemplates = () => {
        setSurveyTemplates([]);

        if (coachId > 0 && functionalArea.AppFunctionalAreaId > 0 && surveyType.SvySurveyTypeId > 0) {
            updateLoadCount(true);
            HttpService.post('/TeamCoach/GetSvySurveyTemplates', {
                cfgFunctionalArea: functionalArea.AppFunctionalAreaId,
                svySurveyType: surveyType.SvySurveyTypeId,
                TeamCoachId: coachId
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AllSurveyTemplates");
                        let allSurveyTemplates = offlineResult.OfflineData.data;
                        let data = [];
                        allSurveyTemplates.forEach(item => {
                            if (item.Template.cfgFunctionalArea === functionalArea.AppFunctionalAreaId && item.Template.svySurveyType === surveyType.SvySurveyTypeId) {
                                data.push(item.Template);
                            }
                        });
                        result.data = data;
                    }
                    setSurveyTemplates(result.data);
                    updateLoadCount(false);
                    if (comeFrom === "RDOAccountVisitation" && rodTab === "Tab1") {

                        var find = false;
                        result.data.forEach((item) => {
                            if (item.Title.toLowerCase() === 'evs rdo client survey') {
                                setSurveyTemplate(item);
                                setSurveyTemplateId(item.SvySurveyTemplateId);
                                find = true;
                            }
                        });

                        if (!find) {
                            setErrorMessage("Cannot find 'EVS RDO Client Survey' Template.");
                            setOpenError(true);
                        }
                        else {
                            updateLocationIcon(true);
                            document.getElementById("Step3").click();
                        }
                    }
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const getSupervisors = () => {
        if (coachId > 0) {
            updateLoadCount(true);
            HttpService.post('/TeamCoach/GetApiSupervisorOrEmployeeSelect', {
                TeamCoachId: coachId.toString(),
                ApiType: "Supervisor"
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "Supervisors");
                        result.data = offlineResult.OfflineData.data;
                    }
                    else {
                        offlineService.removeOfflineBySite(defaultSite.id, "Supervisors");
                        offlineService.addOffline(defaultSite.id, "Supervisors", result);
                    }
                    setSupervisors(result.data);
                    var data = result.data.slice();
                    data.unshift({ PplPerson: 0, Title: "All" });
                    setSupervisorsAll(data);
                    updateLoadCount(false);
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const getEmployees = () => {
        if (coachId > 0) {
            updateLoadCount(true);
            HttpService.post('/TeamCoach/GetApiSupervisorOrEmployeeSelect', {
                TeamCoachId: coachId.toString(),
                ApiType: "Employee"
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "Employees");
                        result.data = offlineResult.OfflineData.data;
                    }
                    else {
                        offlineService.removeOfflineBySite(defaultSite.id, "Employees");
                        offlineService.addOffline(defaultSite.id, "Employees", result);
                    }
                    setEmployees(result.data);
                    updateLoadCount(false);
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const getSurveyTemplateSections = () => {
        let isTemplateId = false;
        let totalQuestionsCount = 0;

        if (surveyTemplate !== null && surveyTemplate !== undefined) {
            if (Array.isArray(surveyTemplate)) {
                if (surveyTemplate.length > 0) {
                    isTemplateId = true;
                }
            }
            else if (surveyTemplate.SvySurveyTemplateId !== undefined) {
                isTemplateId = true;
            }
        }

        if (isTemplateId) {
            setEmployeeDisable(false);
        }
        else {
            setEmployeeDisable(true);
        }

        if (isTemplateId) {
            updateLoadCount(true);
            setSelectedTemplates([]);
            setGeneralComments([]);
            HttpService.post('/TeamCoach/GetSvySurveyTemplateSections', {
                SurveyTemplateId: surveyTemplate.SvySurveyTemplateId.toString()
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AllSurveyTemplates");
                        let allSurveyTemplates = offlineResult.OfflineData.data;
                        let data = allSurveyTemplates.filter(x => x.Template.SvySurveyTemplateId === surveyTemplate.SvySurveyTemplateId);
                        result.data = data[0]?.SvySurveyTemplateSectionView;
                    }
                    setTemplateSections(result.data);
                    setTemplateSectionsBase(JSON.parse(JSON.stringify(result.data)));

                    result.data.forEach((item) => {
                        totalQuestionsCount += item.SvySurveyTemplateQuestion.length;
                    });
                    setTotalQuestions(totalQuestionsCount);
                    updateLoadCount(false);

                    if (generateFromQueue) {
                        if (surveyTemplate.EmployeeMandatory && employee.length !== undefined) {
                            document.getElementById("Step1").click();
                        }
                        else {
                            document.getElementById("Step3").click();
                         }
                    }
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const getCoachId = () => {
        updateLoadCount(true);
        HttpService.post('/TeamCoach/GetIntegratedSystem', {
            GeoLocationId: defaultSite.id
        })
            .then(async (result) => {
                if (result && result.offline) {
                    //get offline data
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "IntegratedSystem");
                    result.data = offlineResult.OfflineData.data;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "IntegratedSystem");
                    offlineService.addOffline(defaultSite.id, "IntegratedSystem", result);
                }
                if (result.data.TeamCoachId > 0) {
                    setCoachId(result.data.TeamCoachId);
                }
                else {
                    setErrorMessage(result.message);
                    setOpenError(true);
                }
                updateLoadCount(false);
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const getCoachQueue = () => {
        if (coachId > 0) {
            updateLoadCount(true);
            HttpService.post('/TeamCoach/GetTeamCoachQueue', {
                DateFrom: dateFrom,
                DateTo: dateTo,
                FunctionalAreaName: functionalAreaName,
                GeoLocationId: defaultSite.id.toString(),
                SupervisorName: supervisorName,
                SurveyTypeName: surveyTypeName,
                TeamCoachId: coachId
            })
                .then(async (result) => {
                    if (result && result.offline) {
                        //get offline data
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "TeamCoachQueue");
                        let coachQueueList = offlineResult.OfflineData.data;
                        let data = coachQueueList.filter(x => (moment(x.CreatedDateTime).isSameOrAfter(dateFrom) && moment(x.CreatedDateTime).isSameOrBefore(dateTo + " 11:59 PM")));
                        result.count = data.length;
                        result.data = data;
                    }

                    if (queueCount === 0) {
                        setQueueCount(result.count);
                        setQueueListBase(result.data);
                    }
                    setQueueList(result.data);
                    updateLoadCount(false);
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const setLocationsOnInit = async () => {
        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AllHirNodes");
        setLocations(offlineResult.OfflineData.data);
    };

    const setLocationsOnRepeat = async (path) => {
        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AllHirNodes");
        var _loations = offlineResult.OfflineData.data.filter(x => { return x.LocationPath && x.LocationPath.indexOf(path) !== -1 });
        setLocation(_loations[0]);
    };

    const getLocations = (random) => {
        var locationPath = locationSearchHistory || "";
        if (coachId > 0) {
            if (random) {
                updateLoadCount(true);
                HttpService.post('/TeamCoach/GetApiHirnodesFlattenedFullHirnodes', {
                    site: defaultSite.id,
                    teamCoachId: coachId,
                    BuildingMandatory: true,
                    FloorMandatory: false,
                    RoomMandatory: false,
                    InspectionDate: inspectionDate,
                    LocationPath: locationPath,
                    Page: 1,
                    Random: random,
                })
                    .then(async (result) => {
                        if (result && result.offline) {
                            //get offline data
                            const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AllHirNodes");
                            let data = offlineResult.OfflineData.data;
                            setLocation(data[parseInt(Math.random() * (data.length - 1))]);
                        }
                        else {
                            if (result.randomData !== null) {
                                setLocation(result.randomData);
                            }
                        }
                        updateLoadCount(false);
                    },
                        (error) => {
                            console.log(error);
                            updateLoadCount(false);
                        });
            }
            else {
                setLocationsOnInit();
            }
        }
    };

    const updateSupervisorIcon = () => {
        let supervisorIcon;
        let supervisorEntered = true;
        let employeeEntered = true;
        let intervieweeEntered = true;

        if (surveyTemplate.SupervisorMandatory && supervisor.length !== undefined)
            supervisorEntered = false;
        if (surveyTemplate.EmployeeMandatory && employee.length !== undefined)
            employeeEntered = false;
        if (surveyTemplate.IntervieweeMandatory && interviewee === "")
            employeeEntered = false;
        if (surveyTemplate.length === undefined && supervisorEntered && employeeEntered && intervieweeEntered) {
            supervisorIcon = <CheckCircleRoundedIcon style={{ color: "Green" }} />
            setLocationDisable(false);
        }
        else {
            supervisorIcon = "2";
            setLocationDisable(true);
            setTemplateDisable(true);
        }

        if (supervisorIcon !== "2" && locationIcon !== "3")
            setTemplateDisable(false);
    };

    const updateLocationIcon = (update) => {
        let locationIcon;

        if ((location && location.length === undefined && location.LocationPath !== null) || update) {
            locationIcon = <CheckCircleRoundedIcon style={{ color: "Green" }} />
            setTemplateDisable(false);
        }
        else {
            locationIcon = "3";
            setTemplateDisable(true);
        }
        setLocationIcon(locationIcon);
    };

    const editSurveyTemplate = (queueData) => {
        let functionalAreaIdTemp = functionalAreaId;
        let surveyTypeIdTemp = surveyTypeId;
        let functionalAreaIndex = functionalAreas.findIndex(item => item.AppFunctionalAreaId === queueData.FunctionalAreaId);
        setFunctionalArea(functionalAreas[functionalAreaIndex]);
        setFunctionalAreaId(functionalAreas[functionalAreaIndex].AppFunctionalAreaId);
        let surveyTypeIndex = surveyTypes.findIndex(item => item.SvySurveyTypeId === queueData.SurveyTypeId);
        setSurveyType(surveyTypes[surveyTypeIndex]);
        setSurveyTypeId(surveyTypes[surveyTypeIndex].SvySurveyTypeId);
        let supervisorIndex = supervisors.findIndex(item => item.PplPerson === queueData.SupervisorPplPerson);
        if (supervisorIndex !== -1) {
            setSupervisor(supervisors[supervisorIndex]);
            setSupervisorId(supervisors[supervisorIndex].PplPerson);
        }
        setEmployee([]);
        setEmployeeId(0);
        setInterviewee("");

        let locationIndex = locations.findIndex(item => item.Hirnode === queueData.Hirnode);
        setLocation(locations[locationIndex]);

        if (functionalAreas[functionalAreaIndex].AppFunctionalAreaId !== functionalAreaIdTemp || surveyTypes[surveyTypeIndex].SvySurveyTypeId !== surveyTypeIdTemp)
            setTemplateId(queueData.TemplateId);
        else if (queueData.TemplateId > 0 && surveyTemplates.length > 0) {
            let templateIndex = surveyTemplates.findIndex(item => item.SvySurveyTemplateId === queueData.TemplateId);
            setSurveyTemplate(surveyTemplates[templateIndex]);
            setSurveyTemplateId(surveyTemplates[templateIndex].SvySurveyTemplateId);
        }
        setSvyGeneratedSurveyId(queueData.svyGeneratedSurveyId);
        setGenerateFromQueue(true);
        setQueueListOpen(false);
        setModified(true);
    };

    const functionalAreaChanged = (e) => {
        let index = functionalAreas.findIndex(item => item.AppFunctionalAreaId === parseInt(e.target.value));
        setFunctionalArea(index === -1 ? [] : functionalAreas[index]);
        setFunctionalAreaId(index === -1 ? 0 : parseInt(e.target.value));
        setSvyGeneratedSurveyId(0);
        setGenerateFromQueue(false);
        setSurveyTypeId(0);
        setSurveyTemplateId(0);
        setSurveyType([]);
        setSurveyTemplate([]);
        setTemplateSections([]);
        setSelectedTemplates([]);
        setModified(true);
    };

    const surveyTypeChanged = (e) => {
        let index = surveyTypes.findIndex(item => item.SvySurveyTypeId === parseInt(e.target.value));
        setSurveyType(index === -1 ? [] : surveyTypes[index]);
        setSurveyTypeId(index === -1 ? 0 : parseInt(e.target.value));
        setSurveyTemplateId(0);
        setSurveyTemplate([]);
        setTemplateSections([]);
        setSelectedTemplates([]);
        setModified(true);
    };

    const surveyTemplateChanged = (e) => {
        let index = surveyTemplates.findIndex(item => item.SvySurveyTemplateId === parseInt(e.target.value));
        setSurveyTemplate(index === -1 ? [] : surveyTemplates[index]);
        setSurveyTemplateId(index === -1 ? 0 : parseInt(e.target.value));
    };

    const supervisorChanged = (e) => {
        let index = supervisors.findIndex(item => item.PplPerson === parseInt(e.target.value));
        setSupervisor(index === -1 ? [] : supervisors[index]);
        setSupervisorId(index === -1 ? 0 : parseInt(e.target.value));
    };

    const employeeChanged = (e) => {
        let index = employees.findIndex(item => item.PplPerson === parseInt(e.target.value));
        setEmployee(index === -1 ? [] : employees[index]);
        setEmployeeId(index === -1 ? 0 : parseInt(e.target.value));
    };

    const intervieweeChanged = (e) => {
        setInterviewee(e.target.value);
    };

    const repeatForm = (props) => {
        var lastIndex = location.LocationPath.lastIndexOf("\\");
        var parentLevelPath = location.LocationPath.substring(0, lastIndex);
        setLocationsOnRepeat(parentLevelPath);
        setActionMessage("")
        setShowMessage(false);
        setGenerateFromQueue(false);
        setSelectedTemplates([]);
        setTemplateSections(JSON.parse(JSON.stringify(templateSectionsBase)));
        //props.goToStep(3);
        handleActiveStep(2, () => { props.goToStep(3) });
    };

    const startNew = (props) => {
        setActionMessage("");
        setLocationSearchHistory("");
        setShowMessage(false);
        resetControls(true);
        //props.goToStep(1);
        handleActiveStep(0, () => { props.goToStep(1) });
    };

    const resetControls = (startNew) => {
        if (!startNew) {
            setFunctionalArea([]);
            setFunctionalAreaId(0);
        }
        setSurveyType([]);
        setSurveyTemplate([]);
        setSupervisor([]);
        setEmployee([]);
        setInterviewee("");
        setLocation([]);
        setSelectedTemplates([]);
        setTemplateSections([]);
        setSurveyTypeId(0);
        setSurveyTemplateId(0);
        setSvyGeneratedSurveyId(0);
        setGenerateFromQueue(false);
        setSupervisorId(0);
        setEmployeeId(0);
        setModified(false);
    };

    const updateData = (item, add) => {
        var data = queueListBase;
        if (add) {
            setQueueCount(queueCount + 1);
            data.push(item);
        }
        else {
            setQueueCount(queueCount - 1);
            let index = data.findIndex(d => d.svyGeneratedSurveyId === item.svyGeneratedSurveyId);
            if (index !== -1)
                data.splice(index, 1);
        }
        setQueueListBase(data);
    };

    const saveCoachQueue = (props) => {
        if (backDrop) {
            return;
        }
        else if (surveyTemplate.SvySurveyTemplateId > 0) {
            let model = {};
            let item = {};
            updateLoadCount(true);
            model.svyGeneratedSurveyId = 0;
            model.templateId = surveyTemplate.SvySurveyTemplateId.toString();
            model.supervisorPplPerson = ((supervisor.length === 0 || supervisor.length !== undefined) ? "0" : supervisor.PplPerson.toString());
            model.Hirnode = location.Hirnode.toString();
            model.svyGenerationType = "2";

            item.CreatedDateTime = ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm:ss", null, defaultSite);
            item.FunctionalAreaId = functionalArea.AppFunctionalAreaId;
            item.FunctionalAreaName = functionalArea.AppFunaTitle;
            item.GeoLocationId = defaultSite.id;
            item.Hirnode = location.Hirnode;
            item.LocationName = location.LocationPath;
            item.SupervisorName = ((supervisor.length === 0 || supervisor.length !== undefined) ? "" : supervisor.Title);
            item.SupervisorPplPerson = ((supervisor.length === 0 || supervisor.length !== undefined) ? 0 : supervisor.PplPerson);
            item.SurveyTypeId = surveyType.SvySurveyTypeId;
            item.SurveyTypeName = surveyType.Title;
            item.TeamCoachId = 0;
            item.TemplateId = surveyTemplate.SvySurveyTemplateId;
            item.TemplateName = surveyTemplate.Title;
            item.svyGeneratedSurveyId = 0;
            item.svyGenerationType = 0;

            HttpService.post('/TeamCoach/AddTeamCoachQueue', model)
                .then(async result => {
                    if (result && result.offline) {
                        await SaveTeamCoachOfflineData(defaultSite.id, model.svyGeneratedSurveyId, "SaveCoachQueue", model, item, "/TeamCoach/AddTeamCoachQueue", false, false);
                        updateData(item, true);
                    }
                    else if (result.error) {
                        setErrorMessage(result.message);
                        setOpenError(true);
                    }
                    else {
                        item.svyGeneratedSurveyId = result.data.svyGeneratedSurveyId;
                        updateData(item, true);
                        await SaveTeamCoachOfflineData(defaultSite.id, result.data.svyGeneratedSurveyId, "SaveCoachQueue", null, item, "/TeamCoach/AddTeamCoachQueue", true, false);
                    }
                    resetControls();
                    //props.goToStep(1);
                    handleActiveStep(0, () => { props.goToStep(1) });
                    updateLoadCount(false);
                },
                    (error) => {
                        console.log(error);
                        updateLoadCount(false);
                    });
        }
    };

    const setAnswersAsNA = (e, surveyTemplateSectionId, updateQuestionCompleted) => {
        e.stopPropagation();
        let data = selectedTemplates;
        let templateIndex = templateSections.findIndex(item => item.SvySurveyTemplateSectionId === surveyTemplateSectionId);
        let templateSection = templateSections[templateIndex];

        templateSection.SvySurveyTemplateQuestion.forEach(x => {
            if (templateSection.SvySurveyRating.Textbox === false) {
                let itemIndex = data.findIndex(d => d.templateQuestionId === x.SvySurveyTemplateQuestionId);
                if (itemIndex === -1)
                    data.push({ templateQuestionId: x.SvySurveyTemplateQuestionId, checkValue: "-1", comments: "", textBoxAnswer: "" });
                else
                    data[itemIndex].checkValue = "-1";
            }
        });
        setSelectedTemplates(data);
        updateQuestionCompleted(null, surveyTemplateSectionId);
    };

    const updateQuestionAnswer = (e, SvySurveyTemplateQuestionId, SvySurveyRatingTagId, updateQuestionCompleted) => {
        let data = selectedTemplates;
        let itemIndex = data.findIndex(item => item.templateQuestionId === SvySurveyTemplateQuestionId);

        if (itemIndex === -1)
            data.push({ templateQuestionId: SvySurveyTemplateQuestionId, checkValue: SvySurveyRatingTagId, comments: "", textBoxAnswer: "" });
        else
            data[itemIndex].checkValue = SvySurveyRatingTagId;
        setSelectedTemplates(data);
        updateQuestionCompleted(data);
    };

    const updateQuestionAnswerComments = (e, SvySurveyTemplateQuestionId, updateQuestionCompleted) => {
        let data = selectedTemplates;
        let itemIndex = data.findIndex(item => item.templateQuestionId === SvySurveyTemplateQuestionId);

        if (itemIndex === -1)
            data.push({ templateQuestionId: SvySurveyTemplateQuestionId, checkValue: 0, comments: e.target.value, textBoxAnswer: "" });
        else
            data[itemIndex].comments = e.target.value;
        setSelectedTemplates(data);
        updateQuestionCompleted(data);
    };

    const updateTextBoxAnswer = (e, SvySurveyTemplateQuestionId, updateQuestionCompleted) => {
        let data = selectedTemplates;
        let itemIndex = data.findIndex(item => item.templateQuestionId === SvySurveyTemplateQuestionId);

        if (itemIndex === -1)
            data.push({ templateQuestionId: SvySurveyTemplateQuestionId, checkValue: 0, comments: "", textBoxAnswer: e.target.value });
        else
            data[itemIndex].textBoxAnswer = e.target.value;
        setSelectedTemplates(data);
        updateQuestionCompleted(data);
    };

    const updateNAQuestionAnswer = (SvySurveyTemplateQuestionId, updateQuestionCompleted) => {
        let data = selectedTemplates;
        let itemIndex = data.findIndex(item => item.templateQuestionId === SvySurveyTemplateQuestionId);
        if (itemIndex === -1)
            data.push({ checkValue: '-1', templateQuestionId: SvySurveyTemplateQuestionId });
        else
            data[itemIndex].checkValue = '-1';

        setSelectedTemplates(data);
        updateQuestionCompleted(data);
    };

    const updateGeneralComments = (e) => {
        let templateComments = generalComments;

        if (templateComments.length === 0)
            templateComments.push(e.target.value);
        else
            templateComments[0] = e.target.value;
        setGeneralComments(templateComments);
    };

    const validate = (onOpenFormError) => {
        if (functionalArea.length !== undefined) {
            onOpenFormError("Please select the Functional Area.");
            return false;
        }
        else if (surveyType.length !== undefined) {
            onOpenFormError("Please select the Survey Type.");
            return false;
        }
        else if (surveyTemplate.length !== undefined) {
            onOpenFormError("Please select the Survey Template.");
            return false;
        }
        else if (surveyTemplate.SupervisorMandatory && supervisor.length !== undefined) {
            onOpenFormError("Please select the Supervisor.");
            return false;
        }
        else if (surveyTemplate.EmployeeMandatory && employee.length !== undefined) {
            onOpenFormError("Please select the Employee.");
            return false;
        }
        else if (surveyTemplate.IntervieweeMandatory && interviewee === "") {
            onOpenFormError("Please enter the Interviewee.");
            return false;
        }
        else if (comeFrom === "RDOAccountVisitation" && rodTab === "Tab1" && interviewee === "") {
            onOpenFormError("Please enter the Interviewee.");
            return false;
        }
        else if (location.length !== undefined && rodTab !== "Tab1") {
            onOpenFormError("Please select the location.");
            return false;
        }
        else if (surveyTemplate.GeneralCommentsMandatory && (generalComments.length === 0 || generalComments[0] === "")) {
            onOpenFormError("Please enter the General Comments.");
            return false;
        }
        else {
            let questionsCount = 0;
            let answersCount = 0;

            templateSections.forEach(item => {
                item.SvySurveyTemplateQuestion.forEach(question => {
                    questionsCount++;
                    let selectedAnswer = selectedTemplates.filter(x => x.templateQuestionId === question.SvySurveyTemplateQuestionId);
                    if (selectedAnswer.length > 0) {
                        if (!item.SvySurveyRating.Textbox || (item.SvySurveyRating.Textbox && selectedAnswer[0].textBoxAnswer !== ""))
                            answersCount++;
                    }
                });
            });

            if (questionsCount === 0) {
                onOpenFormError("Template Questions are not found.");
                return false;
            }
            else if (questionsCount !== answersCount) {
                onOpenFormError("Please fill out the remaining " + (questionsCount - answersCount) + " questions.");
                return false;
            }
        }

        return true;
    };

    const saveSurveyTemplate = (onOpenFormError) => {
        let performedSurveys = [];
        let performedSurvey = {};
        let surveyPerformQuestions = [];
        let surveyPerformRating = {};
        let svyPerformedSurvey = {};
        let model = {};

        if (backDrop) {
            return;
        }
        else if (!validate(onOpenFormError)) {
            return false;
        }

        updateLoadCount(true);
        templateSections.forEach(item => {
            if (Array.isArray(item.SvySurveyTemplateQuestion)) {
                surveyPerformQuestions = [];
                performedSurvey = {};
                surveyPerformRating = {};
                item.SvySurveyTemplateQuestion.forEach(question => {
                    let selectedAnswer = selectedTemplates.filter(x => x.templateQuestionId === question.SvySurveyTemplateQuestionId);
                    let surveyPerformQuestion = {};
                    surveyPerformQuestion.SvySurveyTemplateQuestionId = parseInt(question.SvySurveyTemplateQuestionId);
                    if (selectedAnswer.length > 0) {
                        if (item.SvySurveyRating.Textbox === true) {
                            surveyPerformQuestion.RadioId = "-1";
                            surveyPerformQuestion.TextboxAnswer = selectedAnswer[0].textBoxAnswer;
                        }
                        else {
                            surveyPerformQuestion.RadioId = selectedAnswer[0].checkValue.toString();
                            surveyPerformQuestion.TextboxAnswer = "";
                        }
                        surveyPerformQuestion.Comments = selectedAnswer[0].comments;
                    }
                    surveyPerformQuestions.push(surveyPerformQuestion);
                });
                performedSurvey.SvySurveyTemplateQuestion = surveyPerformQuestions;
                surveyPerformRating.Textbox = item.SvySurveyRating.Textbox;
                performedSurvey.SvySurveyRating = surveyPerformRating;
                performedSurveys.push(performedSurvey);
            }
        });

        svyPerformedSurvey.SiteId = defaultSite.id;
        svyPerformedSurvey.svySurveyTemplate = surveyTemplate.SvySurveyTemplateId;
        svyPerformedSurvey.Hirnode = location.Hirnode;
        svyPerformedSurvey.TeamCoachId = parseInt(coachId, 10);
        svyPerformedSurvey.Title = defaultSite.name;
        svyPerformedSurvey.InspectionDate = inspectionDate;
        svyPerformedSurvey.Supervisor = supervisor.PplPerson;
        svyPerformedSurvey.Employee = employee.PplPerson;
        svyPerformedSurvey.Interviewee = interviewee;
        svyPerformedSurvey.Hirnode = (comeFrom === "RDOAccountVisitation") ? (getHirnode() ? getHirnode() : location.Hirnode) : location.Hirnode; //hirnode from ADO Account Visitation
        svyPerformedSurvey.GeneralComments = generalComments.length === 0 ? "" : generalComments[0];
        TransactionTime.end();
        TransactionTime.updateData(svyPerformedSurvey);

        model.SvyPerformedSurvey = svyPerformedSurvey;
        model.SurveyTemplateSections = performedSurveys;
        model.delQueueId = 0;
        if (comeFrom !== "RDOAccountVisitation") {
            model.svyGeneratedSurveyId = svyGeneratedSurveyId;
        }

        HttpService.post('/TeamCoach/SaveSurvey', model)
            .then(async result => {
                if (result && result.offline) {
                    model.SvyPerformedSurvey.EntryNote = "TeamLeadOffLine";
                    await SaveTeamCoachOfflineData(defaultSite.id, 0, "SaveSurvey", model, null, "/TeamCoach/SaveSurvey", false, false);
                    updateLoadCount(false);
                    setActionMessage("TeamCoach Form has been completed offline and the data is saved locally, Choose an action:")
                    setShowMessage(true);
                }
                else {
                    updateLoadCount(false);

                    if (comeFrom === "RDOAccountVisitation" || comeFrom === "Round") {
                        goToComeFrom(result.SvyPerformedSurveyId);
                        return;
                    }

                    setActionMessage("TeamCoach Form ID: " + result.SvyPerformedSurveyId + " has been completed successfully, Choose an action:")
                    setShowMessage(true);
                }

                if (svyGeneratedSurveyId > 0) {
                    updateData(model, false);
                    await SaveTeamCoachOfflineData(defaultSite.id, svyGeneratedSurveyId, "SaveCoachQueue", null, model, "/TeamCoach/AddTeamCoachQueue", true, true);
                }
                setModified(false);
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    function isElementVisible(element) {
        const container = document.getElementById("templateContainer");
        const containerRect = container.getBoundingClientRect();
        const { bottom, height, top } = element.getBoundingClientRect();
        return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
    };

    function sectionUp() {
        const element = document.getElementById("templateContainer");
        const rect = element.getBoundingClientRect();
        let sectionIndex = 0;

        for (var index = 0; index < refSections.current.length; index++) {
            const sectionRect = refSections.current[index].getBoundingClientRect();
            if (parseInt(sectionRect.top) >= parseInt(rect.top)) {
                sectionIndex = index - 1;
                break;
            }
        }

        if (sectionIndex !== -1)
            refSections.current[sectionIndex].scrollIntoView({ behavior: 'smooth' });
    };

    function sectionDown() {
        const element = document.getElementById("templateContainer");
        const rect = element.getBoundingClientRect();
        let sectionIndex = 0;

        for (var index = 0; index < refSections.current.length; index++) {
            const sectionRect = refSections.current[index].getBoundingClientRect();
            if (sectionRect.top >= rect.top) {
                sectionIndex = index;
                break;
            }
        }

        if (sectionIndex !== refSections.current.length - 1)
            sectionIndex++;
        refSections.current[sectionIndex].scrollIntoView({ behavior: 'smooth' });
    };

    function questionUp() {
        let questionIndex = 0;

        for (var index = 0; index < refQuestions.current.length; index++) {
            if (isElementVisible(refQuestions.current[index])) {
                questionIndex = index - 1;
                break;
            }
        }

        if (questionIndex === -1)
            questionIndex = 0;

        refQuestions.current[questionIndex].scrollIntoView({ behavior: 'smooth' });
    };

    function questionDown() {
        let questionIndex = 0;

        for (var index = 0; index < refQuestions.current.length; index++) {
            if (isElementVisible(refQuestions.current[index])) {
                questionIndex = index + 1;
                break;
            }
        }

        if (questionIndex === refQuestions.current.length)
            questionIndex--;

        refQuestions.current[questionIndex].scrollIntoView({ behavior: 'smooth' });
    };

   
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const switchStepDisabled = (index) => {
        if (index === 1) {
            return employeeDisable;
        } else if (index === 2) {
            return locationDisable;
        }
        else if (index === 3) {
            return templateDisable;
        }
        return false;
    };
    const handleActiveStep = (index, callback) => {
        if (switchStepDisabled(index)) {
            return;
        }
        setActiveStep(index);
        if (callback) callback();
    };

    const handleNext = (callback) => {
        if (switchStepDisabled(activeStep+1)) {
            return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        if (callback) callback();
    };

    const handleBack = (callback) => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        if (callback) callback();
    };

    const radioDivStyle = {
        display: 'block',
        backgroundColor: 'white',
        boxShadow: '#2da4ca99',
        borderRadius: '4px',
        marginRight: '15px',
        minHeight: '40px',
        cursor: 'pointer',
        marginBottom: '5px',
        padding: '0 10px',
        border: '1px solid #cdc8c8'
    };

    useEffect(() => {
        TransactionTime.begin('TeamCoach');
        getCoachId();
        getFunctionalAreas();
        getSurveyTypes();
        if (userDetail.length === 0)
            getCurrentUserDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getCoachQueue();
        getLocations(false);
        getSupervisors();
        getEmployees();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coachId]);

    useEffect(() => {
        getSurveyTemplates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coachId, functionalArea, surveyType]);

    useEffect(() => {
        if (templateId > 0 && surveyTemplates.length > 0) {
            let templateIndex = surveyTemplates.findIndex(item => item.SvySurveyTemplateId === templateId);
            setSurveyTemplate(surveyTemplates[templateIndex]);
            setSurveyTemplateId(surveyTemplates[templateIndex].SvySurveyTemplateId);
            setTemplateId(0);
            updateSupervisorIcon();
            updateLocationIcon();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyTemplates]);

    useEffect(() => {
        getSurveyTemplateSections();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyTemplate]);

    useEffect(() => {
        updateSupervisorIcon();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyTemplate, supervisor, employee, interviewee]);

    useEffect(() => {
        if (comeFrom === "Round" && locations.length > 0) {
            let locationIndex = -1;
            let locationPath = roundLocationPath;

            locationPath = locationPath.replace(defaultSite.name, "");
            locationPath = locationPath.toLowerCase();

            for (let index = 0; index < locations.length; index++) {
                if (locations[index].LocationPath !== null && locations[index].LocationPath.toLowerCase().indexOf(locationPath) > -1) {
                    locationIndex = index;
                    break;
                }
            }

            if (locationIndex !== -1) {
                setLocationExists(true);
                setLocation(locations[locationIndex]);
            }
            else {
                setErrorMessage("The location [" + defaultSite.name + locationPath + "] does not exists in TeamCoach.");
                setOpenError(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations]);

    useEffect(() => {
        updateLocationIcon();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        if (loadCount > 0)
            setBackDrop(true);
        else
            setBackDrop(false);
    }, [loadCount]);

    const Stats = ({
        currentStep,
        firstStep,
        goToStep,
        lastStep,
        nextStep,
        previousStep,
        totalSteps,
        step,
    }) => (
        <>
            {
                currentStep === 1 &&
                <div className='d-flex flex-fill justify-content-end align-self-center ml-auto col-12 col-xl-2' style={{ fontSize: '21px', fontWeight: '200', maxWidth: '125px', minWidth: '150px' }}>
                    {
                        (comeFrom !== "RDOAccountVisitation" && comeFrom !== "Round") &&
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ width: "108px", display: currentStep === 1 ? 'inline' : 'none' }}
                            type="button"
                            onClick={openQueueList}
                        >
                            Queue({queueCount})
                        </Button>
                    }
                </div>
            }
            <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />} style={{ background: currentTheme.background }}>
                {steps.map((label, index) => (
                    <Step id={"Step" + index} key={label} onClick={() => handleActiveStep(index, () => { goToStep(index + 1)} )}>
                        <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </>
    );

    const SurveyType = props => {

        return (
            <div>
                <Stats step={0} {...props} />
                <h3>Survey Type</h3>
                <br></br>
                <Typography variant="subtitle2" gutterBottom>
                    Inspection Date <span style={{color:'red'}}>*</span>
                </Typography>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        required
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        id="InspectionDate"
                        format="MM/dd/yyyy"
                        size="small"
                        value={inspectionDate}
                        onChange={(date) => {
                            setInspectionDate(date);
                            setModified(true);
                        }}
                        margin="normal"
                        InputAdornmentProps={{ position: "start" }}
                        style={{ marginTop:"0px" }}
                        PopoverProps={{
                            anchorOrigin: { horizontal: "left", vertical: "bottom" },
                            transformOrigin: { horizontal: "left", vertical: "top" }
                        }}
                    />
                </MuiPickersUtilsProvider>
                <br></br><br></br>
                <Typography variant="subtitle2" gutterBottom>
                    Functional Area <span style={{ color: 'red' }}>*</span>
                </Typography>
                    <FormControl required variant="outlined" margin="dense" style={{ marginTop: "0px" , width: '100%' }}>
                    <Select style={{ width: '100%', color: 'inherit' }}
                        native
                        size="small"
                        disabled={generateFromQueue}
                        value={functionalAreaId}
                        onChange={functionalAreaChanged}
                    >
                        <option aria-label="None" key="0" value="" />
                        {
                            functionalAreas.map((option, key) => {
                                return <option key={option.AppFunctionalAreaId} value={option.AppFunctionalAreaId} label={option.AppFunaTitle} >{option.AppFunaTitle}</option>;
                            })
                        }
                    </Select>
                </FormControl>
                <br></br><br></br>
                <Typography variant="subtitle2" gutterBottom>
                    Survey Type <span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl required variant="outlined" margin="dense" style={{ marginTop: "0px", width: '100%' }}>
                    <Select style={{ width: '100%', color: 'inherit' }}
                        native
                        size="small"
                        disabled={generateFromQueue}
                        value={surveyTypeId}
                        onChange={surveyTypeChanged}
                    >
                        <option aria-label="None" key="0" value="" />
                        {
                            surveyTypes.map((option, key) => {
                                return <option key={option.SvySurveyTypeId} value={option.SvySurveyTypeId} label={option.Title}>{option.Title}</option>;
                            })
                        }
                    </Select>
                </FormControl>
                <br></br><br></br>
                <Typography variant="subtitle2" gutterBottom>
                    Survey Template <span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl required variant="outlined" margin="dense" style={{ marginTop: "0px",width: '100%' }}>
                    <Select style={{ width: '100%', color: 'inherit' }}
                        native
                        size="small"
                        disabled={generateFromQueue}
                        value={surveyTemplateId}
                        onChange={surveyTemplateChanged}
                    >
                        <option aria-label="None" key="0" value="" />
                        {
                            surveyTemplates.map((option, key) => {
                                return <option key={option.SvySurveyTemplateId} value={option.SvySurveyTemplateId} label={option.Title}>{option.Title}</option>;
                            })
                        }
                    </Select>
                </FormControl>
                <div className="mt-4 d-flex justify-content-end">
                    <Button size="small" variant="contained" color="primary" style={{ background: currentTheme.secondary}} onClick={() => { handleNext(() => { props.goToStep(props.currentStep + 1) }) }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>
        );
    };

    const ChooseLocation = props => {
       
        const [locationSearchHistoryInside, setLocationSearchHistoryInside] = useState("");
        const locationSearchChanged = (e) => { setLocationSearchHistoryInside(e.target.value); console.log(e.target.value) };
        const locationBlur = () => { setLocationSearchHistory(locationSearchHistoryInside); console.log(locationSearchHistoryInside); };
        useEffect(() => {
            setLocationSearchHistoryInside(locationSearchHistory);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [locationSearchHistory]);

        return (
            <div>
                <Stats step={3} {...props} />
                <h3>Location</h3>
                <br />
                <div className="d-flex align-items-end">
                    <div className="flex-fill">
                        <Typography variant="subtitle2" gutterBottom>
                            Location <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <Autocomplete
                            disableClearable
                            id="Location"
                            openOnFocus
                            disabled={generateFromQueue || (comeFrom === "Round" && locationExists)}
                            value={location}
                            options={locations}
                            getOptionLabel={(option) => option.LocationPath || ""}
                            getOptionSelected={(option, value) => option.LocationPath === value.LocationPath}
                            onChange={(event, option) => { setLocation(option); setLocationSearchHistory(locationSearchHistoryInside); }}
                            style={{ width: "100%", clear: "both" }}
                            renderInput={(params) => <TextField {...params} className={classes.locationInput} variant="outlined" onChange={locationSearchChanged} onBlur={locationBlur} />}
                        />
                    </div>
                   
                    <div style={{ marginBottom: '4px', marginRight: "-35px"}}>
                        {
                           

                            (comeFrom !== "Round") &&
                            <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                className={`mr-3 ${classes.button}`}
                                style={{ background: currentTheme.secondary, width: "50px", backgroundColor: "snow", boxShadow: "none" }}
                                type="button"
                                disabled={generateFromQueue}
                                onClick={e => getLocations(true)}
                            >
                                <img className="icon" src={RandomIcon} alt="Random" />
                            </Button>
                        }
                    </div>
                </div>
                
                <div className="mt-4 d-flex justify-content-between">
                    <div>
                        {
                            (comeFrom !== "RDOAccountVisitation" && comeFrom !== "Round") &&
                            <Button
                                variant="outlined"
                                size="small"
                                color="primary"
                                className={`mr-3 ${classes.button}`}
                                style={{
                                    color: currentTheme.secondary, marginLeft: "10px", width: "150px"
                                }}
                                type="button"
                                onClick={e => saveCoachQueue(props)}
                                disabled={templateDisable || generateFromQueue}
                            >
                                Send to Queue
                            </Button>
                        }
                    </div>
                   
                    <div>
                        <Button variant="outlined" size="small" className="mr-3" style={{ color: currentTheme.secondary }}
                            onClick={() => { handleBack(() => { props.goToStep(props.currentStep - 1) }) }}
                        >
                            Back
                        </Button>
                        <Button size="small" variant="contained" color="primary" style={{ background: currentTheme.secondary }} onClick={() => { handleNext(() => { props.goToStep(props.currentStep + 1) }) }}>
                            Next
                        </Button>
                    </div>
                   
                </div>
            </div>
        );
    };

    const CompleteForm = props => {
        const [intervieweeForRDO, setIntervieweeForRDO] = useState("");
        const intervieweeChangedForRDO = (e) => { setIntervieweeForRDO(e.target.value); };
        const intervieweeBlur = () => { setInterviewee(intervieweeForRDO); };
        useEffect(() => {
            setIntervieweeForRDO(interviewee);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [interviewee]);

        return (
            <div>
                <Stats step={4} {...props} />
                <h3>Survey</h3>
                {!showMessage &&
                    <div className={classes.root} style={{ clear: "both" }}>
                        {
                            comeFrom === "RDOAccountVisitation" && rodTab === "Tab1" &&
                            <div>
                                <TextField
                                    id="IntervieweeForROD"
                                    label="Interviewee *"
                                    size="small"
                                    value={intervieweeForRDO}
                                    onChange={intervieweeChangedForRDO}
                                    onBlur={intervieweeBlur}
                                    variant="outlined"
                                    style={{ width: "100%", clear: "both", marginTop: "10px" }}
                                />
                            </div>

                        }
                        <BuildForm templateSections={templateSections} />
                    </div>
                }

                <ContentDialog open={showMessage} title={actionMessage} maxWidth={"sm"} noActions={true} >
                    <div style={{ clear: "both", padding: '10px' }}>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            style={{ color: currentTheme.secondary,width: "100%", marginRight: "10px", float: "left", marginBottom: "20px" }}
                            type="button"
                            onClick={() => repeatForm(props)}
                        >
                            Repeat Form
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            style={{ color: currentTheme.secondary,width: "100%", marginRight: "10px", float: "left", marginBottom: "20px" }}
                            type="button"
                            onClick={() => startNew(props)}
                        >
                            Start New
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            style={{ color: currentTheme.secondary,width: "100%", marginRight: "10px", float: "left", marginBottom: "20px" }}
                            type="button"
                            onClick={() => cancel()}
                        >
                            Exit Coach
                        </Button>
                    </div>
                </ContentDialog>
                
                {/*{showMessage &&*/}
                {/*    <div style={{ clear: "both" }}>*/}
                {/*        <br />*/}
                {/*        <h4 style={{ color: currentTheme.text, width: "100%" }}>{actionMessage}</h4>*/}
                {/*        <br />*/}
                {/*        <Button*/}
                {/*            variant="contained"*/}
                {/*            color="primary"*/}
                {/*            size="small"*/}
                {/*            className={classes.button}*/}
                {/*            style={{ background: "#00b5ad", width: "120px", marginRight: "10px", float: "left" }}*/}
                {/*            type="button"*/}
                {/*            onClick={() => repeatForm(props)}*/}
                {/*        >*/}
                {/*            Repeat Form*/}
                {/*        </Button>*/}
                {/*        <Button*/}
                {/*            variant="contained"*/}
                {/*            color="primary"*/}
                {/*            size="small"*/}
                {/*            className={classes.button}*/}
                {/*            style={{ background: "#2185d0", width: "120px", marginRight: "10px", float: "left" }}*/}
                {/*            type="button"*/}
                {/*            onClick={() => startNew(props)}*/}
                {/*        >*/}
                {/*            Start New*/}
                {/*        </Button>*/}
                {/*        <Button*/}
                {/*            variant="contained"*/}
                {/*            color="primary"*/}
                {/*            size="small"*/}
                {/*            className={classes.button}*/}
                {/*            style={{ background: "#db2828", width: "120px", marginRight: "10px", float: "left" }}*/}
                {/*            type="button"*/}
                {/*            onClick={() => cancel()}*/}
                {/*        >*/}
                {/*            Exit Coach*/}
                {/*        </Button>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
        );
    };

    const BuildForm = props => {
        let prevCount = 0;
        let currentCount = 0;
        let completedQuestionsCount = 0;
        const [templateSectionsCopy, setTemplateSectionsCopy] = useState(props.templateSections);
        const [errorFormMessage, setErrorFormMessage] = useState("");
        const [openFormError, setOpenFormError] = useState(false);

        if (labelRef.current && labelRef.current.value === '') {
            labelRef.current.value = completedQuestionsCount + " out of " + totalQuestions + " completed";
        }
        const questionCompleted = (data, svySurveyTemplateSectionId) => {
            var _templateSections = JSON.parse(JSON.stringify(templateSectionsCopy));

            _templateSections.forEach((_item, index) => {
                _item.SectionCheckedQuestion = 0;
                _item.SectionNAResponseCount = 0;
                _item.RadioGroup = false;
                _item.SvySurveyTemplateQuestion.forEach(x => {
                    if (svySurveyTemplateSectionId && svySurveyTemplateSectionId === _item.SvySurveyTemplateSectionId && _item.SvySurveyRating.Textbox === false) {
                        x.SvySurveyRatingTagId = "-1";
                    }

                    if (!svySurveyTemplateSectionId) {
                        var exists = data.find(f => f.templateQuestionId === x.SvySurveyTemplateQuestionId);
                        if (exists) {
                            if (_item.SvySurveyRating.Textbox === false) {
                                x.SvySurveyRatingTagId = exists.checkValue.toString();
                                x.Comments = exists.comments;
                            }
                            else {
                                x.SvySurveyRatingTagId = exists.textBoxAnswer === "" ? undefined : exists.textBoxAnswer;
                                x.TextBoxAnswer = exists.textBoxAnswer;
                                x.Comments = exists.comments;
                            }
                        }
                    }

                    if (x.SvySurveyRatingTagId) {
                        if ((_item.SvySurveyRating.Textbox === false && x.SvySurveyRatingTagId !== "0") || (_item.SvySurveyRating.Textbox && x.TextBoxAnswer !== "")) {
                            _item.SectionCheckedQuestion++;
                            completedQuestionsCount++;
                        }

                        if (x.SvySurveyRatingTagId === "-1")
                            _item.SectionNAResponseCount++;
                        _item.RadioGroup = _item.SvySurveyRating.Textbox ? false : true;
                    }

                });
            });

            labelRef.current.value = completedQuestionsCount + " out of " + totalQuestions + " completed";
            _templateSections.CompletedQuestions = completedQuestionsCount;
            setTemplateSectionsCopy(_templateSections);
        };

        useEffect(() => {
            if (selectedTemplates.length > 0) {
                questionCompleted(selectedTemplates);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const onOpenFormError = (message) => {
            setErrorFormMessage(message);
            setOpenFormError(true);
        };

        const closeFormError = (message) => {
            setErrorFormMessage("");
            setOpenFormError(false);
        };

        return (
            <div>
                <Snackbar open={openFormError} autoHideDuration={3000} onClose={closeFormError} style={{ height: "100%" }}>
                    <Alert onClose={closeFormError} severity="error">
                        {errorFormMessage}
                    </Alert>
                </Snackbar>
                <div id="templateContainer" style={{ height: '400px', overflowY: 'auto' }}>
                    {
                        templateSectionsCopy.map((item, index) => {
                            if (index > 0) {
                                currentCount += prevCount;
                            }
                            prevCount = item.SvySurveyTemplateQuestion.length;
                            return (
                                <div key={index}>
                                    <div ref={ref => { refSections.current[index] = ref; }}>
                                        <ExpansionPanel defaultExpanded={true} style={{ background: currentTheme.background}}>
                                            <ExpansionPanelSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-label="Expand"
                                                aria-controls="additional-actions1-content"
                                                id="additional-actions1-header"
                                                style={{ backgroundColor: "#3399cc" }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    style={{ background: ((item.RadioGroup && item.SectionNAResponseCount === item.SvySurveyTemplateQuestion.length) ? "#00FFFF" : "#FFFFFF"), color: "black", width: "10px" }}
                                                    onClick={e => setAnswersAsNA(e, item.SvySurveyTemplateSectionId, questionCompleted)}
                                                >
                                                    NA
                                                </Button>
                                                <h4 style={{ paddingLeft: "10px" }}>{item.Title} <span>({item.SectionCheckedQuestion || 0} - {item.SvySurveyTemplateQuestion.length} completed)</span></h4>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails style={{display:"block"}}>
                                                <div key={index}>
                                                    <QuestionOptions data={item.SvySurveyTemplateQuestion} updateQuestionCompleted={questionCompleted} surveyRating={item.SvySurveyRating} questionCount={currentCount} />
                                                </div>
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                        <Divider style={{ height: '2px', backgroundColor: 'red', marginTop: '2px' }} /><br />
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <GeneralComments submitDisabled={templateSectionsCopy.CompletedQuestions !== totalQuestions} onOpenFormError={onOpenFormError} />
            </div>);
    };

    const QuestionOptions = props => {
        let questionOptions = props.data.map((question, index) => {
            return <div key={question.SvySurveyTemplateQuestionId} id={index} style={{ marginBottom: '20px' }}>
                <div ref={ref => { refQuestions.current[props.questionCount + index] = ref; }}>
                    <h4 style={{ color: '#7f8081', width: "100%" }}>{index + 1}.&nbsp;{question.Question}</h4>
                    <RadioGroup aria-label="" name={"Q" + question.SvySurveyTemplateQuestionId} value={question.SvySurveyRatingTagId || null}>
                        <QuestionAnswer data={question.SvySurveyRatingTag} updateQuestionCompleted={props.updateQuestionCompleted} SvySurveyRatingTagId={question.SvySurveyRatingTagId} textBoxAnswer={question.TextBoxAnswer} surveyRating={props.surveyRating} svySurveyTemplateQuestionId={question.SvySurveyTemplateQuestionId} sectionId={question.SvySurveyTemplateSectionId} />
                        <QuestionNA surveyRating={props.surveyRating} svySurveyTemplateQuestionId={question.SvySurveyTemplateQuestionId} updateQuestionCompleted={props.updateQuestionCompleted} />
                        <QuestionComments isVisible={question.CommentsAllowed} svySurveyTemplateQuestionId={question.SvySurveyTemplateQuestionId} updateQuestionCompleted={props.updateQuestionCompleted} comments={question.Comments} />
                    </RadioGroup>
                </div>
            </div>
        })
        return questionOptions;
    };

    const QuestionAnswer = props => {
        if (props.surveyRating !== null) {
            if (props.surveyRating.Textbox === false) {
                let questionOptions = props.data.map((question, index) => {
                    return <div key={question.SvySurveyRatingTagId} style={radioDivStyle} onClick={(e) => updateQuestionAnswer(e, props.svySurveyTemplateQuestionId, question.SvySurveyRatingTagId, props.updateQuestionCompleted)}>
                        <FormControlLabel style={{color:'black',margin:"0px"}} value={question.SvySurveyRatingTagId.toString()} control={<Radio />} label={question.Title} />
                    </div>
                })
                return questionOptions;
            }
            else {
                return <div><input type="text" className="dd-textbox" style={{ width: '300px' }} value={props.textBoxAnswer || ""} onChange={(e) => updateTextBoxAnswer(e, props.svySurveyTemplateQuestionId, props.updateQuestionCompleted)} /></div>
            }
        }
        else {
            return <div></div>
        }
    };

    const QuestionNA = props => {
        if (props.surveyRating !== null) {
            if (props.surveyRating.Textbox === false) {
                return <div style={radioDivStyle} onClick={(e) => updateNAQuestionAnswer(props.svySurveyTemplateQuestionId, props.updateQuestionCompleted)} >
                    <FormControlLabel style={{ color: 'black', margin: "0px" }} value="-1" control={<Radio />} label="NA" />
                </div>
            }
            else {
                return <div></div>
            }
        }
        else {
            return <div></div>
        }
    };

    const QuestionComments = props => {
        if (props.isVisible === true) {
            return <div style={{ marginTop: '10px' }}>Comments: <input type="text" className="dd-textbox" style={{ width: '300px' }} value={props.comments || ""} onChange={(e) => updateQuestionAnswerComments(e, props.svySurveyTemplateQuestionId, props.updateQuestionCompleted)} /></div>
        }
        else {
            return <div></div>
        }
    };

    const GeneralComments = props => {
        return <div style={{ bottom: '0px' }}>
            <div style={{ clear: "both", height: "20px" }}></div>
            <div>
                {surveyTemplate.GeneralCommentsMandatory ? "*" : ""}General Comments: <input type="text" className="dd-textbox" style={{ width: '400px' }} onChange={(e) => updateGeneralComments(e)} /><br /><br />
            </div>
            <div className='d-flex flex-fill justify-content-between align-items-center'>
                <div>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "100px", marginRight: "10px", float: "left" }}
                        onClick={() => { saveSurveyTemplate(props.onOpenFormError) }}
                        disabled={props.submitDisabled}
                    >
                        Submit
                    </Button>
                </div>
                <div>
                    <TextField
                        variant="standard"
                        margin="normal"
                        disabled
                        inputRef={labelRef}
                        InputProps={{
                            disableUnderline: true,
                            style: { color: "#7f8081", fontSize: "large" }
                        }}
                    />
                    <input style={{ display: "none" }} ref={buttonRef} onClick={() => { saveSurveyTemplate(props.onOpenFormError) }} />
                </div>
                <div>
                    <Button
                        disabled={templateSections.length <= 1}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "20px", float: "right", marginRight: "5px" }}
                        onClick={sectionDown}>
                        <GetAppIcon />
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "20px", float: "right", marginRight: "5px" }}
                        onClick={questionDown}>
                        <KeyboardArrowDownOutlinedIcon />
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "20px", float: "right", marginRight: "5px" }}
                        onClick={questionUp}>
                        <ExpandLessOutlinedIcon />
                    </Button>
                    <Button
                        disabled={templateSections.length <= 1}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "20px", float: "right", marginRight: "5px" }}
                        onClick={sectionUp}>
                        <PublishIcon />
                    </Button>
                </div>
            </div>
        </div>
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <SaveWarningDialog open={saveConfirmOpen} onDisContinue={saveConfirmClose} onContinue={cancel} />
                <FullScreenDialog open={queueListOpen} title="Queue List" hideConfirm={true} maxWidth={"lg"} close={() => setQueueListOpen(false)} currentTheme={currentTheme}>
                    <div>
                        <div className="col-md-12">
                            <div className="form-inline">
                                <div className="col-sm-2 mb-3">
                                    <Typography variant="subtitle2" gutterBottom>
                                        Start Date 
                                    </Typography>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            required
                                            autoOk
                                            id="DateFrom"
                                            format="MM/dd/yyyy"
                                            disableFuture="true"
                                            value={dateFrom}
                                            onChange={date => setDateFrom(date)}
                                            InputAdornmentProps={{ position: "start" }}
                                            size="small"
                                            variant="inline"
                                            inputVariant="outlined"
                                            style={{ width: "100%" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-sm-2 mb-3">
                                    <Typography variant="subtitle2" gutterBottom>
                                        End Date
                                    </Typography>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            required
                                            autoOk
                                            id="DateTo"
                                            format="MM/dd/yyyy"
                                            disableFuture="true"
                                            minDate={dateFrom}
                                            value={dateTo}
                                            onChange={date => setDateTo(date)}
                                            InputAdornmentProps={{ position: "start" }}
                                            size="small"
                                            variant="inline"
                                            inputVariant="outlined"
                                            style={{ width: "100%" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div className="col-sm-8"></div>
                                <br />
                                <div className="col-sm-2">
                                    <Typography variant="subtitle2" gutterBottom>
                                        Functional Area
                                    </Typography>
                                    <Autocomplete
                                        id="FunctionalAreaFilter"
                                        size="small"
                                        openOnFocus
                                        options={functionalAreasAll}
                                        defaultValue={functionalAreasAll[0]}
                                        getOptionLabel={(option) => option.AppFunaTitle}
                                        onChange={(event, option) => setFunctionalAreaName(option.AppFunaTitle)}
                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <Typography variant="subtitle2" gutterBottom>
                                        Survey Type
                                    </Typography>
                                    <Autocomplete
                                        id="SurveyTypeFilter"
                                        size="small"
                                        openOnFocus
                                        options={surveyTypesAll}
                                        defaultValue={surveyTypesAll[0]}
                                        getOptionLabel={(option) => option.Title}
                                        onChange={(event, option) => setSurveyTypeName(option.Title)}
                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    <Typography variant="subtitle2" gutterBottom>
                                        Supervisor
                                    </Typography>
                                    <Autocomplete
                                        id="Supervisorfilter"
                                        size="small"
                                        openOnFocus
                                        options={supervisorsAll}
                                        defaultValue={supervisorsAll[0]}
                                        getOptionLabel={(option) => option.Title}
                                        onChange={(event, option) => setSupervisorName(option.Title)}
                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                    />
                                </div>
                                <div className="col-sm-2 ml-auto">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        style={{ background: currentTheme.secondary, width: "110px" }}
                                        type="button"
                                        onClick={getCoachQueue}
                                    >
                                        Search
                                    </Button>
                                </div>
                            </div>
                        </div><br />
                        <div className="react-bootstrap-table">
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Date</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Location</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Template</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Survey Type</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Supervisor</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Functional Area</th>
                                        <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}></th>
                                    </tr>
                                </thead>
                                <tbody className="text-capitalize">
                                    {queueList?.map((item, index) => (
                                        <tr key={index}>
                                            <td style={rowStyle(index)}>{index + 1}</td>
                                            <td style={rowStyle(index)}>{moment(item.CreatedDateTime).format('MM/DD/YYYY hh:mm A')}</td>
                                            <td style={rowStyle(index)}>{getShortName(item.LocationName)}</td>
                                            <td style={rowStyle(index)}>{item.TemplateName}</td>
                                            <td style={rowStyle(index)}>{item.SurveyTypeName}</td>
                                            <td style={rowStyle(index)}>{item.SupervisorName}</td>
                                            <td style={rowStyle(index)}>{item.FunctionalAreaName}</td>
                                            <td style={rowStyle(index)}>
                                                <Tooltip title="Edit" arrow>
                                                    <EditIcon onClick={() => { editSurveyTemplate(item); }} style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} />
                                                </Tooltip>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </FullScreenDialog>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            {/*{*/}
                            {/*    (comeFrom !== "RDOAccountVisitation" && comeFrom !== "Round") && <IconButton edge="start" color="inherit"  aria-label="back">*/}
                            {/*        <KeyboardBackspaceIcon />*/}
                            {/*    </IconButton>*/}
                            {/*}*/}
                            {
                            (comeFrom !== "RDOAccountVisitation") &&
                                    <SmallMenu moduleName={"Coach"} modified={modified} saveCallback={() => saveData()} closeDialog={() => (comeFrom === "Round") ? goToComeFrom() : undefined} />
                            }
                            <Grid container direction="row" alignItems="center">
                            <Grid item>
                                <Typography variant="h6" >
                                    <span onClick={triggerSave} className="nav-text">
                                        TeamLead 
                                    </span>
                                     / TeamCoach
                                </Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>

                <Card color="primary" className="page-container" style={{ boxShadow: "none"}}>
                       
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <StepWizard>
                                <SurveyType />
                                <SupervisorEmployee
                                surveyTemplate={surveyTemplate}
                                supervisors={supervisors}
                                supervisorId={supervisorId}
                                onSupervisorChange={supervisorChanged}
                                employees={employees}
                                employeeId={employeeId}
                                onEmployeeChange={employeeChanged}
                                interviewee={interviewee}
                                onIntervieweeChange={intervieweeChanged}
                                generateFromQueue={generateFromQueue}
                                Stats={Stats}
                                handleActiveStep={handleActiveStep}
                                handleBack={handleBack}
                                handleNext={handleNext}
                                switchStepDisabled={switchStepDisabled}
                                currentTheme={currentTheme}
                                />
                                <ChooseLocation />
                                <CompleteForm />
                            </StepWizard>
                    </CardBody>
                    </Card>
                <InactiveTimeout disContinue={cancel} />
            </ThemeProvider>
        </React.Fragment>
    );
};
